// ── Helpers shared by the registration and edit chats ──
// Both flows accept the same answers from the same people, so they have to
// clean and validate them the same way. Keeping these in one place stops the
// two pages from drifting into different ideas of a valid phone number.

import axios from "axios";

/* Same key the existing Add Business page uses. */
export const API_KEY = "AIzaSyDMC5uUfcSScgVY9AGqsGQwYm8P6_LmyYg";

/* Kerala only has one state row in the DB; the district list is keyed to it. */
export const STATE_ID = 1;

export const MAX_IMAGE_MB = 5;

export const nowTime = () =>
  new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

export const onlyDigits = (v) => (v || "").replace(/\D/g, "");

/* Shop owners paste numbers as "+91 98765 43210" or "098765 43210".
   Clean it up rather than rejecting them. */
export const normalizeMobile = (raw) => {
  let d = onlyDigits(raw);
  if (d.length === 12 && d.startsWith("91")) d = d.slice(2);
  if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
  return d;
};

export const normalizeLink = (raw) => {
  const v = (raw || "").trim();
  if (!v) return "";
  if (/^https?:\/\//i.test(v)) return v;
  return `https://${v}`;
};

export const looksLikeLink = (raw) => /\.[a-z]{2,}/i.test((raw || "").trim());

/* Phone cameras produce 5–10 MB photos; shrink before upload so weak
   networks don't make the chat look frozen. */
export const compressImage = (file) =>
  new Promise((resolve) => {
    if (!/^image\//.test(file.type) || /svg/.test(file.type)) return resolve(file);
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const max = 1600;
        let { width, height } = img;
        if (width <= max && height <= max && file.size < 900 * 1024) {
          return resolve(file);
        }
        const scale = Math.min(1, max / Math.max(width, height));
        width = Math.round(width * scale);
        height = Math.round(height * scale);
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (blob) => {
            if (!blob) return resolve(file);
            resolve(
              new File([blob], file.name.replace(/\.[^.]+$/, "") + ".jpg", {
                type: "image/jpeg",
              })
            );
          },
          "image/jpeg",
          0.82
        );
      };
      img.onerror = () => resolve(file);
      img.src = reader.result;
    };
    reader.onerror = () => resolve(file);
    reader.readAsDataURL(file);
  });

/* One location answer fills location_info, district, post office and pincode. */
export const reverseGeocode = async (lat, lng) => {
  const out = { locality: "", districtName: "", postOffice: "", pincode: "" };
  try {
    const { data } = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${API_KEY}`
    );
    const parts = data?.results?.[0]?.address_components || [];
    const pick = (type) => parts.find((c) => c.types.includes(type))?.long_name || "";
    out.locality = pick("locality") || pick("sublocality_level_1") || pick("neighborhood");
    out.districtName =
      pick("administrative_area_level_3") ||
      pick("administrative_area_level_2") ||
      out.locality;
    out.postOffice = pick("sublocality_level_1") || pick("neighborhood") || out.locality;
    out.pincode = pick("postal_code");
  } catch (e) {
    /* Geocoding is a convenience only — the coordinates are what matter. */
  }
  return out;
};
